import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./CompanyBoillerplate.css";
import { trackEvent, trackPageView } from "../../utils/tracking";

function CompanyBoilerplate() {
  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/Company-Boilerplate",
      "jmf_company-boilerplate"
    );
    // trackPageView(
    //   "http://localhost:710/Company-Boilerplate",
    //   "jmf_company-boilerplate"
    // );

    trackEvent({
      category: "Static Page",
      action: "CompanyBoilerPlate Page Loaded",
      label: "jmf_company-boilerplate",
      value: 1,
    });
  }, []);
  return (
    <>
    <main id="main-content" tabindex="-1">
      <section class="company-bilerplate-sc">
        <nav aria-label="Breadcrumb">
        <Container>
          <Row>
            <Col>
              <ul className="navigator-arrow">
                <li>
                  <a href="/" aria-label="Home">
                    <i class="fa fa-home" aria-hidden="true"></i>
                  </a>{" "}
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                </li>
                <li>
                  <a href="/Company-Boilerplate">
                    <i>Company Boilerplate</i>
                  </a>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
        </nav>
        <Container>
          <Row>
            <Col sm={12}>
              {/* <h2 className='comp'>Company Boilerplate</h2>     */}

              <div className="distributer-h1 tab-wrapper">
                <h1 className="header-sc" style={{textAlign: "center"}}>Company Boilerplate</h1>
              </div>

              <p className="font-bio">
                JM Financial Asset Management Ltd is a leading Indian asset management company that offers a wide range of investment solutions to individual and institutional investors. With a team of seasoned investment professionals and a strong track record of performance, JM Financial Asset Management Ltd. is committed to providing its clients with innovative and customized investment solutions that meet their unique needs and objectives.
              </p>

              <p className="font-bio">
                {/* The JM Financial Mutual Fund network has expanded significantly and spans across 16 locations, including the recent additions of Bhubaneswar and Indore. We have increased our distribution strength to over 24,000+ partners and are currently servicing approximately 4.97lakh investor folios. As of 31st July 2024, the AUM stood at 11,077crores. */}
                {/* The JM Financial Mutual Fund network has expanded
                  significantly and spans across 17 locations, including the
                  recent additions of Bhubaneswar and Indore. Our 26,000+
                  partners are currently servicing approximately 7.78 lakh
                  investor folios. As of 30th November 2024, the AUM stood at
                  ₹13,946.77 crores. */}
              
              The JM Financial Mutual Fund network has expanded significantly and spans across 29 locations, including Nashik & Bhopal. Our 29,500+ partners are currently servicing approximately 8.82 lakh investor folios. As of 31 Mar 2026, the AUM stood ₹ 12,000.03 Crores.
              </p>
              {/* <p className='font-bio'>

                                The AMC Board network has expanded significantly and spans across 13 locations, including the recent additions
                                of Lucknow and Baroda in FY 23. We have increased our distribution strength to over 18,000+ which
                                includes 1400+ new partners and are currently servicing 1,44,159 lakh investor folios.
                                As of 31st March 2023, the AUM of JM Financial Mutual Fund was at Rs. 2,962 crs.
                            </p> */}
            </Col>
          </Row>
        </Container>
      </section>

    </main>
    </>
  );
}

export default CompanyBoilerplate;
